import React from 'react';
import { useLaunchParams } from '@telegram-apps/sdk-react';
import { ExchangeConnectList } from '@/components/ExchangeConnectList';
import { ReferralBottomNav } from '@/components/ReferralBottomNav';
import { AutotradeTriggerManager } from '@/components/AutotradeTriggerManager';

export const SettingsPageMobile: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id;

  return (
    <div className="min-h-screen bg-primary flex flex-col">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="max-w-2xl mx-auto space-y-6">
          <ExchangeConnectList userId={userId?.toString() || ''} />
          <AutotradeTriggerManager userId={userId?.toString() || ''} />
        </div>
      </div>
      <ReferralBottomNav />
    </div>
  );
};
